import React,{ useEffect, useState } from "react";
import axios from "axios";
import Mexp from "math-expression-evaluator";
import { token, queryParams, domainurl } from './constants/global';

const SetParameter = ({ previousStep,previousValue,triggerNextStep,step,steps,datas }) => {
    console.log("setparam");
    console.log(previousStep.message);
    console.log({datas});
    console.log(datas.ParameterName);
    
    const[msg, setMsg]=useState("");

    useEffect(()=>{
        
        if(datas.ParameterName=="Url")
        {
            let urldata = <a href={datas.Value} target="_blank">{datas.Value}</a>;
            setMsg(urldata);
            //axios.post(domainurl + '/insertchat',{"token":token, "botmsg":datas.Value, "usermsg": previousStep.message, "client_id": queryParams, "channel":"web"})
            axios.post(domainurl + '/insertchat',{"token":token, "client_id": "919154313830","channel":"web","usermsg": previousStep.message,"botmsg":datas.Value})
            
        }

        // if(datas.ParameterName=="Script")
        // {
        //     console.log("$***$**$**&");
        //     console.log(datas.Value);
        //     const mexp = new Mexp();
        //     const expvalue = mexp.eval(datas.Value);
        //     console.log(expvalue);
        //     axios.post(domainurl + '/insertchat',{"token":token, "botmsg":response.data.msg, "usermsg": previousStep.message, "client_id": queryParams})
        //     setMsg(expvalue);
        // }
        
    },[]);
    
    return (
        <div>
            
        {msg}
        
        </div>
        
    );
   
};
export default SetParameter;
